export const getManualUpdateValidation = (firstValue, secondValue) => ({
  actualValidation: `${firstValue} value can not be in the future`,
  tobtValidation: `TOBT value must between EOBT + ${firstValue} and EOBT - ${secondValue}`,
  equalValue: `Please make sure to update the ${firstValue} value or click ${
    secondValue || "close"
  }`,
  tobtOutLimit: `TOBT value change should be more than ${firstValue} min of EOBT or previously TOBT`,
});
